import { memo } from "react";
import { useNavBlocker } from "../../hooks/useNavBlocker/useNavBlocker";
import { PendingChangesModal } from "../PendingChangesModal/PendingChangesModal";

interface NavBlockerModalProps {
  isDirty: boolean;
  isSaveDisabled?: boolean;
  onSave?: () => void | Promise<void>;
}

export const NavBlockerModal = memo(
  ({ isDirty, isSaveDisabled, onSave }: NavBlockerModalProps) => {
    const blocker = useNavBlocker(isDirty);

    return (
      <PendingChangesModal
        blocker={blocker}
        isSaveDisabled={isSaveDisabled}
        onSave={onSave}
      />
    );
  }
);
